import { render, staticRenderFns } from "./LanguageBox.vue?vue&type=template&id=05c1e238&scoped=true"
import script from "./LanguageBox.vue?vue&type=script&lang=js"
export * from "./LanguageBox.vue?vue&type=script&lang=js"
import style0 from "./LanguageBox.vue?vue&type=style&index=0&id=05c1e238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1e238",
  null
  
)

export default component.exports